'use strict';

function _interopDefault (ex) { return (ex && (typeof ex === 'object') && 'default' in ex) ? ex['default'] : ex; }

var _slicedToArray = _interopDefault(require('@babel/runtime-corejs2/helpers/slicedToArray'));
var _toConsumableArray = _interopDefault(require('@babel/runtime-corejs2/helpers/toConsumableArray'));
var _Array$isArray = _interopDefault(require('@babel/runtime-corejs2/core-js/array/is-array'));
var _getIterator = _interopDefault(require('@babel/runtime-corejs2/core-js/get-iterator'));
var _JSON$stringify = _interopDefault(require('@babel/runtime-corejs2/core-js/json/stringify'));
var _Date$now = _interopDefault(require('@babel/runtime-corejs2/core-js/date/now'));
var _objectSpread = _interopDefault(require('@babel/runtime-corejs2/helpers/objectSpread'));
var _Map = _interopDefault(require('@babel/runtime-corejs2/core-js/map'));
var _classCallCheck = _interopDefault(require('@babel/runtime-corejs2/helpers/classCallCheck'));
var _regeneratorRuntime = _interopDefault(require('@babel/runtime-corejs2/regenerator'));
var _asyncToGenerator = _interopDefault(require('@babel/runtime-corejs2/helpers/asyncToGenerator'));

var LONG_INTERVAL = 30 * 1000;
var BATCHLENGTH = 1000;
var isBatchReporting = false; // 是否正在批量上报

var queue = {
  stack: [],
  status: 'completed',
  next: function () {
    var _next = _asyncToGenerator(
    /*#__PURE__*/
    _regeneratorRuntime.mark(function _callee() {
      var task;
      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              this.status = 'pending';
              task = this.stack.shift();
              _context.next = 4;
              return task.handler(task.data);

            case 4:
              if (this.stack.length) {
                _context.next = 6;
                break;
              }

              return _context.abrupt("return", this.status = 'completed');

            case 6:
              this.next();

            case 7:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, this);
    }));

    function next() {
      return _next.apply(this, arguments);
    }

    return next;
  }()
};

var Stat = function Stat() {
  var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
      _ref$report = _ref.report,
      report = _ref$report === void 0 ? function (data) {
    return data;
  } : _ref$report,
      _ref$router = _ref.router,
      router = _ref$router === void 0 ? null : _ref$router,
      _ref$onceNodeView = _ref.onceNodeView,
      onceNodeView = _ref$onceNodeView === void 0 ? true : _ref$onceNodeView,
      _ref$showConsole = _ref.showConsole,
      showConsole = _ref$showConsole === void 0 ? false : _ref$showConsole;

  _classCallCheck(this, Stat);

  this.onceNodeView = onceNodeView;
  this.showConsole = showConsole;
  this.report = report;
  this.router = router; // 页面浏览历史记录

  this.pageHistory = [];
  this.clickCbs = new _Map();
  this.nodeList = new _Map();
  this.init();
}; // 点击事件上报


Stat.prototype.bindNode = function (el, binding) {
  var _this = this;

  // 是否统计node浏览
  if (binding.value.viewId) {
    this.nodeList.set(el, binding.value);
  }

  this.clickCbs.set(el, function (e) {
    return _this.clickReport(binding.value);
  });
  el.addEventListener('click', this.clickCbs.get(el).bind(this));
}; // 解绑


Stat.prototype.unbind = function (el) {
  this.nodeList["delete"](el);
  el.removeEventListener('click', this.clickCbs.get(el).bind(this));
}; // 点击事件上报


Stat.prototype.clickReport = function (params) {
  var immediately = typeof params.immediately === 'boolean' ? params.immediately : true;
  params.id = params.id || params.clickId;
  var data = this.initReportData(_objectSpread({
    type: 'click'
  }, params));
  if (this.showConsole) console.log('click', data);

  if (immediately) {
    this.immediateReport(data);
  } else {
    this.lazyReport(data);
  }
}; // 浏览事件上报


Stat.prototype.viewReport =
/*#__PURE__*/
function () {
  var _ref2 = _asyncToGenerator(
  /*#__PURE__*/
  _regeneratorRuntime.mark(function _callee2(params) {
    var immediately, data;
    return _regeneratorRuntime.wrap(function _callee2$(_context2) {
      while (1) {
        switch (_context2.prev = _context2.next) {
          case 0:
            immediately = typeof params.immediately === 'boolean' ? params.immediately : true;
            params.id = params.id || params.viewId;
            data = this.initReportData(_objectSpread({
              type: 'view'
            }, params));
            if (this.showConsole) console.log('view', data);

            if (immediately) {
              this.immediateReport(data);
            } else {
              this.lazyReport(data);
            }

          case 5:
          case "end":
            return _context2.stop();
        }
      }
    }, _callee2, this);
  }));

  return function (_x) {
    return _ref2.apply(this, arguments);
  };
}(); // 自定义事件上报


Stat.prototype.customReport = function (params) {
  var immediately = typeof params.immediately === 'boolean' ? params.immediately : true;
  var data = this.initReportData(_objectSpread({}, params));
  if (this.showConsole) console.log(data);

  if (immediately) {
    this.immediateReport(data);
  } else {
    this.lazyReport(data);
  }
}; // 批量上报


Stat.prototype.lazyReport =
/*#__PURE__*/
function () {
  var _ref3 = _asyncToGenerator(
  /*#__PURE__*/
  _regeneratorRuntime.mark(function _callee3(data) {
    var now, last_stat_ts, logs, _iteratorNormalCompletion, _didIteratorError, _iteratorError, _iterator, _step, log, handler;

    return _regeneratorRuntime.wrap(function _callee3$(_context3) {
      while (1) {
        switch (_context3.prev = _context3.next) {
          case 0:
            this.recycle(data);
            now = _Date$now();
            last_stat_ts = localStorage.getItem('last_stat_ts');
            logs = JSON.parse(localStorage.getItem('stat_data')) || [];

            if (!((!last_stat_ts || now - last_stat_ts >= LONG_INTERVAL) && logs.length && !isBatchReporting)) {
              _context3.next = 28;
              break;
            }

            isBatchReporting = true;
            logs = slice(logs, BATCHLENGTH);
            localStorage.setItem('stat_data', _JSON$stringify([]));
            _iteratorNormalCompletion = true;
            _didIteratorError = false;
            _iteratorError = undefined;
            _context3.prev = 11;

            for (_iterator = _getIterator(logs); !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
              log = _step.value;
              handler = this._report.bind(this);

              if (!queue.stack.length && queue.status === 'completed') {
                queue.stack.push({
                  data: log,
                  handler: handler
                });
                queue.next();
              } else {
                queue.stack.push({
                  data: log,
                  handler: handler
                });
              }
            }

            _context3.next = 19;
            break;

          case 15:
            _context3.prev = 15;
            _context3.t0 = _context3["catch"](11);
            _didIteratorError = true;
            _iteratorError = _context3.t0;

          case 19:
            _context3.prev = 19;
            _context3.prev = 20;

            if (!_iteratorNormalCompletion && _iterator["return"] != null) {
              _iterator["return"]();
            }

          case 22:
            _context3.prev = 22;

            if (!_didIteratorError) {
              _context3.next = 25;
              break;
            }

            throw _iteratorError;

          case 25:
            return _context3.finish(22);

          case 26:
            return _context3.finish(19);

          case 27:
            isBatchReporting = false;

          case 28:
          case "end":
            return _context3.stop();
        }
      }
    }, _callee3, this, [[11, 15, 19, 27], [20,, 22, 26]]);
  }));

  return function (_x2) {
    return _ref3.apply(this, arguments);
  };
}(); // 错误回收


Stat.prototype.recycle = function (data) {
  var errors = JSON.parse(localStorage.getItem('stat_data')) || [];
  if (_Array$isArray(data)) errors = [].concat(_toConsumableArray(errors), _toConsumableArray(data));else if (Object.prototype.toString.call(data) === '[object Object]') errors.push(data);else return;
  localStorage.setItem('stat_data', _JSON$stringify(errors));
}; // 即时上传


Stat.prototype.immediateReport =
/*#__PURE__*/
function () {
  var _ref4 = _asyncToGenerator(
  /*#__PURE__*/
  _regeneratorRuntime.mark(function _callee4(data) {
    var now, last_recycle_ts, logs, _iteratorNormalCompletion2, _didIteratorError2, _iteratorError2, _iterator2, _step2, log, handler, _handler;

    return _regeneratorRuntime.wrap(function _callee4$(_context4) {
      while (1) {
        switch (_context4.prev = _context4.next) {
          case 0:
            now = _Date$now();
            last_recycle_ts = localStorage.getItem('last_recycle_ts');
            logs = JSON.parse(localStorage.getItem('stat_data')) || [];

            if (!(last_recycle_ts && now - last_recycle_ts >= LONG_INTERVAL && logs.length && !isBatchReporting)) {
              _context4.next = 30;
              break;
            }

            isBatchReporting = true;
            logs.push(data);
            logs = slice(logs, BATCHLENGTH);
            localStorage.setItem('stat_data', _JSON$stringify([]));
            _iteratorNormalCompletion2 = true;
            _didIteratorError2 = false;
            _iteratorError2 = undefined;
            _context4.prev = 11;

            for (_iterator2 = _getIterator(logs); !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
              log = _step2.value;
              handler = this._report.bind(this);

              if (!queue.stack.length && queue.status === 'completed') {
                queue.stack.push({
                  data: log,
                  handler: handler
                });
                queue.next();
              } else {
                queue.stack.push({
                  data: log,
                  handler: handler
                });
              }
            }

            _context4.next = 19;
            break;

          case 15:
            _context4.prev = 15;
            _context4.t0 = _context4["catch"](11);
            _didIteratorError2 = true;
            _iteratorError2 = _context4.t0;

          case 19:
            _context4.prev = 19;
            _context4.prev = 20;

            if (!_iteratorNormalCompletion2 && _iterator2["return"] != null) {
              _iterator2["return"]();
            }

          case 22:
            _context4.prev = 22;

            if (!_didIteratorError2) {
              _context4.next = 25;
              break;
            }

            throw _iteratorError2;

          case 25:
            return _context4.finish(22);

          case 26:
            return _context4.finish(19);

          case 27:
            isBatchReporting = false;
            _context4.next = 32;
            break;

          case 30:
            _handler = this._report.bind(this);

            if (!queue.stack.length && queue.status === 'completed') {
              queue.stack.push({
                data: data,
                handler: _handler
              });
              queue.next();
            } else {
              queue.stack.push({
                data: data,
                handler: _handler
              });
            }

          case 32:
          case "end":
            return _context4.stop();
        }
      }
    }, _callee4, this, [[11, 15, 19, 27], [20,, 22, 26]]);
  }));

  return function (_x3) {
    return _ref4.apply(this, arguments);
  };
}();

Stat.prototype._report =
/*#__PURE__*/
function () {
  var _ref5 = _asyncToGenerator(
  /*#__PURE__*/
  _regeneratorRuntime.mark(function _callee5(data) {
    var succeed;
    return _regeneratorRuntime.wrap(function _callee5$(_context5) {
      while (1) {
        switch (_context5.prev = _context5.next) {
          case 0:
            _context5.next = 2;
            return this.report(data);

          case 2:
            succeed = _context5.sent;

            if (!(typeof succeed !== 'boolean')) {
              _context5.next = 5;
              break;
            }

            return _context5.abrupt("return");

          case 5:
            if (!succeed) {
              localStorage.setItem('last_recycle_ts', _Date$now());
              this.recycle(data);
            } else {
              localStorage.setItem('last_stat_ts', _Date$now());
            }

          case 6:
          case "end":
            return _context5.stop();
        }
      }
    }, _callee5, this);
  }));

  return function (_x4) {
    return _ref5.apply(this, arguments);
  };
}();

Stat.prototype.clearStorage =
/*#__PURE__*/
_asyncToGenerator(
/*#__PURE__*/
_regeneratorRuntime.mark(function _callee6() {
  var logs, _iteratorNormalCompletion3, _didIteratorError3, _iteratorError3, _iterator3, _step3, log;

  return _regeneratorRuntime.wrap(function _callee6$(_context6) {
    while (1) {
      switch (_context6.prev = _context6.next) {
        case 0:
          logs = JSON.parse(localStorage.getItem('stat_data')) || [];

          if (logs.length) {
            _context6.next = 3;
            break;
          }

          return _context6.abrupt("return");

        case 3:
          logs = slice(logs, BATCHLENGTH);
          _iteratorNormalCompletion3 = true;
          _didIteratorError3 = false;
          _iteratorError3 = undefined;
          _context6.prev = 7;
          _iterator3 = _getIterator(logs);

        case 9:
          if (_iteratorNormalCompletion3 = (_step3 = _iterator3.next()).done) {
            _context6.next = 16;
            break;
          }

          log = _step3.value;
          _context6.next = 13;
          return this.report(log);

        case 13:
          _iteratorNormalCompletion3 = true;
          _context6.next = 9;
          break;

        case 16:
          _context6.next = 22;
          break;

        case 18:
          _context6.prev = 18;
          _context6.t0 = _context6["catch"](7);
          _didIteratorError3 = true;
          _iteratorError3 = _context6.t0;

        case 22:
          _context6.prev = 22;
          _context6.prev = 23;

          if (!_iteratorNormalCompletion3 && _iterator3["return"] != null) {
            _iterator3["return"]();
          }

        case 25:
          _context6.prev = 25;

          if (!_didIteratorError3) {
            _context6.next = 28;
            break;
          }

          throw _iteratorError3;

        case 28:
          return _context6.finish(25);

        case 29:
          return _context6.finish(22);

        case 30:
          localStorage.removeItem('stat_data');

        case 31:
        case "end":
          return _context6.stop();
      }
    }
  }, _callee6, this, [[7, 18, 22, 30], [23,, 25, 29]]);
}));

function slice() {
  var array = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
  var piece = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : BATCHLENGTH;
  var result = [];

  do {
    var pieceArray = array.splice(0, piece);
    result.push(pieceArray);
  } while (array.length > 0);

  return result;
} // 计算节点是否可以上报


Stat.prototype.nodeReport = function () {
  var _iteratorNormalCompletion4 = true;
  var _didIteratorError4 = false;
  var _iteratorError4 = undefined;

  try {
    for (var _iterator4 = _getIterator(this.nodeList.entries()), _step4; !(_iteratorNormalCompletion4 = (_step4 = _iterator4.next()).done); _iteratorNormalCompletion4 = true) {
      var _step4$value = _slicedToArray(_step4.value, 2),
          el = _step4$value[0],
          params = _step4$value[1];

      var _el$getBoundingClient = el.getBoundingClientRect(),
          left = _el$getBoundingClient.left,
          top = _el$getBoundingClient.top;

      var offsetWidth = el.offsetWidth,
          offsetHeight = el.offsetHeight;

      if ( // 在窗口内
      left >= 0 - offsetWidth / 3 && left <= innerWidth - offsetWidth / 3 && top >= 0 - offsetHeight / 3 && top <= innerHeight - offsetHeight / 3) {
        this.viewReport(params);
        if (this.onceNodeView) this.nodeList["delete"](el);
      }
    }
  } catch (err) {
    _didIteratorError4 = true;
    _iteratorError4 = err;
  } finally {
    try {
      if (!_iteratorNormalCompletion4 && _iterator4["return"] != null) {
        _iterator4["return"]();
      }
    } finally {
      if (_didIteratorError4) {
        throw _iteratorError4;
      }
    }
  }
}; // 页面显示与隐藏事件上报


Stat.prototype.init = function () {
  var _this2 = this;

  // console.log(currentPath,this.router,this.router.options.routes)
  this.router.afterEach(function (to, from) {
    // 第一个页面加入页面历史记录
    _this2.pageHistory.push(to.fullPath); // 页面是否自动统计


    if (to.meta.autoReport !== false && to.meta.pageName) {
      _this2.viewReport({
        id: '10002',
        args: {
          screen: to.meta.pageName,
          visible: 1
        }
      });
    }

    if (from.meta.autoReport !== false && from.meta.pageName) {
      _this2.viewReport({
        type: 'hide',
        id: '10002',
        args: {
          screen: from.meta.pageName,
          visible: 0
        }
      });
    }
  }); // 页面滚动时检查节点是否可以上报

  var timer;
  window.addEventListener('scroll', function (e) {
    clearTimeout(timer);
    timer = setTimeout(_this2.nodeReport.bind(_this2), 500);
  });
}; // 初始化上报数据


Stat.prototype.initReportData = function () {
  var _ref7 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
      _ref7$type = _ref7.type,
      _ref7$target = _ref7.target,
      _ref7$page = _ref7.page,
      page = _ref7$page === void 0 ? this.router.currentRoute.fullPath : _ref7$page,
      _ref7$pageFrom = _ref7.pageFrom,
      pageFrom = _ref7$pageFrom === void 0 ? this.pageHistory[this.pageHistory.length - 2] : _ref7$pageFrom,
      _ref7$pageParams = _ref7.pageParams,
      pageParams = _ref7$pageParams === void 0 ? _objectSpread({}, this.router.currentRoute.query) : _ref7$pageParams,
      _ref7$args = _ref7.args,
      args = _ref7$args === void 0 ? {} : _ref7$args,
      id = _ref7.id;

  return {
    // type,
    // target,
    // page,
    // pageFrom,
    // pageParams,
    args: args,
    ts: _Date$now(),
    id: id
  };
};

var index = {
  instance: {},
  install: function install(Vue) {
    var _ref = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
        _ref$report = _ref.report,
        report = _ref$report === void 0 ? function (data) {
      return data;
    } : _ref$report,
        router = _ref.router,
        _ref$onceNodeView = _ref.onceNodeView,
        onceNodeView = _ref$onceNodeView === void 0 ? true : _ref$onceNodeView,
        _ref$showConsole = _ref.showConsole,
        showConsole = _ref$showConsole === void 0 ? false : _ref$showConsole;

    var stat = new Stat({
      report: report,
      router: router,
      onceNodeView: onceNodeView,
      showConsole: showConsole
    });
    this.instance = stat;
    Vue.prototype.$nodeReport = stat.nodeReport.bind(stat);
    Vue.prototype.$clickReport = stat.clickReport.bind(stat);
    Vue.prototype.$viewReport = stat.viewReport.bind(stat);
    Vue.prototype.$report = stat.customReport.bind(stat);
    Vue.prototype.$clearStatStorage = stat.clearStorage.bind(stat);
    Vue.directive('stat', {
      inserted: function inserted(el, binding) {
        return stat.bindNode(el, binding);
      },
      componentUpdated: function componentUpdated(el, binding) {
        return stat.unbind(el) && stat.bindNode(el, binding);
      },
      unbind: function unbind(el) {
        return stat.unbind(el);
      }
    });
  }
};

module.exports = index;
//# sourceMappingURL=index.js.map
